module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0749.335acf6f.jpg";